import * as Scrivito from "scrivito";
import IconComponent from "../../Components/Icon";
import InPlaceEditingPlaceholder from "../../Components/InPlaceEditingPlaceholder";

Scrivito.provideComponent("IconContainerWidget", ({ widget }) => {
  const icons = widget.get("iconList");

  if (!icons.length) {
    return (
      <InPlaceEditingPlaceholder center>
        Select icons in the widget properties.
      </InPlaceEditingPlaceholder>
    );
  }

  return (
    <div className="icon-list text-center">
      {icons.map((item) => {
        const icon = item.get("icon");
        const link = item.get("link");
        const iconSize = `
          is-${item.get("size") || 300}
          is-md-${item.get("sizeTablet") || 300}
          is-sm-${item.get("sizeMobile") || 300}
        `;
        const iconColor = `text-${item.get("iconColor") || "default"}`;

        return (
          <IconComponent
            icon={icon}
            size={iconSize}
            link={link}
            color={iconColor}
            key={item.id()}
          />
        );
      })}
    </div>
  );
});
